import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate } from '@angular/router';
import { isPlatformServer } from '@angular/common';

import { Store, select } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';
import { take, map } from 'rxjs/operators';

import { State, FlightBasket, Stage } from '../interfaces';
import { getBasketFlights, getBasketPassengerIds } from '../store/selectors';
import { StatusActions } from '../store/actions';

@Injectable()
export class BasketGuard implements CanActivate {
  constructor(
    private store$: Store<State>,
    @Inject(PLATFORM_ID) private platform: string
  ) {}

  canActivate(): Observable<boolean> {
    if (isPlatformServer(this.platform)) {
      // Always return true on server so that client handles the requests
      return of(true);
    }

    return combineLatest([
      this.store$.pipe(select(getBasketFlights)),
      this.store$.pipe(select(getBasketPassengerIds)),
    ]).pipe(
      take(1),
      map(([flights, passengerIds]: [FlightBasket[], string[]]) => {
        if (!flights?.length || !passengerIds?.length) {
          return this.deny();
        }

        return true;
      })
    );
  }

  private deny(): false {
    this.store$.dispatch(StatusActions.setStage({ stage: Stage.PASSENGERS }));
    return false;
  }
}
